export default "__VITE_ASSET__sSOATwfI__"